import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import dayjs from 'dayjs';

import AthletesOnHoldPageHeader from './components/AthletesOnHoldPageHeader';
import AthletesOnHoldTable from './components/AthletesOnHoldTable';
import { SearchFilters } from './types';

const AthletesOnHold = (): JSX.Element => {
  const initialSearchFiltersValue: SearchFilters = {
    date: dayjs().endOf('day').toDate(),
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('athlete_package__athlete__first_name');

  return (
    <>
      <AthletesOnHoldPageHeader
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
      />
      <AthletesOnHoldTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default AthletesOnHold;
